import { mapState } from 'vuex';
export default {
  data() {
    return {
      visibleInterceptPopup: false
    };
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      ipLocation: state => state.ipLocation
    }),
    interceptTitle() {
      return this.letter?.productInterceptPopupTitle || '';
    },
    interceptTip() {
      return this.letter?.productInterceptPopupTip || '';
    },
    interceptConfirm() {
      return this.letter?.productInterceptPopupConfirm || '';
    }
  },
  methods: {
    showInterceptPopup() {
      this.visibleInterceptPopup = true;
    },
    hideInterceptPopup() {
      this.visibleInterceptPopup = false;
    },
    handleProductIntercept(item) {
      const interceptProductIdList = [
        'ztm.app.credit37',
        'ztm.app.credit38',
        'ztm.app.credit39',
        'ztm.app.credit40',
        'ztm.app.credit41',
        'ztm.app.credit42',
        'ztm.app.credit43',
        'ztm.app.credit44',
        'ztm.app.credit45',
        'ztm.app.credit46'
      ];
      if (
        item?.PRODUCT_ID &&
        +this.gameId === 191 &&
        this?.ipLocation === 'RU' &&
        interceptProductIdList.includes(item.PRODUCT_ID)
      ) {
        this.showInterceptPopup();
        return false;
      }
      return true;
    }
  }
};
